// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"NewsletterForm__wrapper__11nwz","submitResult":"NewsletterForm__submitResult__1jWtz","actionWrapper":"NewsletterForm__actionWrapper__Y5y7g","wrapper2faOptions":"NewsletterForm__wrapper2faOptions__RNsqn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NewsletterForm/NewsletterForm.css
// module id = 3079
// module chunks = 0